import { render, staticRenderFns } from "./HistoryUpsertDialog.vue?vue&type=template&id=fb464654&scoped=true"
import script from "./HistoryUpsertDialog.vue?vue&type=script&lang=ts"
export * from "./HistoryUpsertDialog.vue?vue&type=script&lang=ts"
import style0 from "./HistoryUpsertDialog.vue?vue&type=style&index=0&id=fb464654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb464654",
  null
  
)

export default component.exports